export default function(token: string, ssopostback: string) {
  const postForm = document.createElement("form");
  postForm.action = ssopostback;
  postForm.method = "POST";
  postForm.innerHTML = `
  <input target="_blank" type="hidden" name="token" value="${token}" />
  <input type="submit" style="visibility: hidden;"/>`;
  document.querySelector("body").appendChild(postForm);
  postForm.submit();
}
